module.exports = __webpack_public_path__ + "img/QueXian03.0f17e41e.jpg";